// extracted by mini-css-extract-plugin
export var active = "_hp-7";
export var blink = "_hp-8";
export var dropDownSelector = "_hp-4";
export var dropDownWrapper = "_hp-3";
export var fakeCursor = "_hp-6";
export var fontSizeButton = "_hp-9";
export var formQuillEditor = "_hp-0";
export var pressed = "_hp-a";
export var qlBlank = "_hp-1";
export var textFormattingToolbar = "_hp-2";
export var textToolbarOption = "_hp-5";